<svelte:options tag={null} />

<script lang="ts">
  import type { TooltipPosition } from './tooltip.types';

  export let id: string;
  export let text: string;
  export let position: TooltipPosition;
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
  function getClasses(position: TooltipPosition) {
    const classes = ['mc-tooltip'];

    if (position) {
      classes.push(`mc-tooltip--${position}`);
    }
    return classes.join(' ');
  }
</script>

<div
  class="{getClasses(position)} {userClass}"
  aria-describedby={id}
  {...attributes}
>
  <slot />
  <span {id} class="mc-tooltip__content" role="tooltip">
    {text}
  </span>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.tooltip';
</style>
